import { IconSvgProps } from '../types';

export const List = ({ size }: IconSvgProps) => (
  <svg
    id="icon-content-list"
    width={size}
    height={size}
    viewBox="0 0 64 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <path
            d="M61.43,44.63 C62.85,44.63 64,45.78 64,47.2 C64,48.58 62.91,49.71 61.55,49.77 L61.43,49.77 L24.86,49.77 C23.44,49.77 22.29,48.62 22.29,47.2 C22.29,45.82 23.37,44.69 24.74,44.63 L24.86,44.63 L61.43,44.63 Z"
            opacity="0.5"
          />
          <circle cx="6.86" cy="46.92" r="6.85714" />
          <path
            d="M61.43,4.63 C62.85,4.63 64,5.78 64,7.2 C64,8.58 62.91,9.71 61.55,9.77 L61.43,9.77 L24.86,9.77 C23.44,9.77 22.29,8.62 22.29,7.2 C22.29,5.82 23.37,4.69 24.74,4.63 L24.86,4.63 L61.43,4.63 Z"
            opacity="0.5"
          />
          <circle cx="6.86" cy="6.92" r="6.85714" />
          <path
            d="M61.43,24.63 C62.85,24.63 64,25.78 64,27.2 C64,28.58 62.91,29.71 61.55,29.77 L61.43,29.77 L24.86,29.77 C23.44,29.77 22.29,28.62 22.29,27.2 C22.29,25.82 23.37,24.69 24.74,24.63 L24.86,24.63 L61.43,24.63 Z"
            opacity="0.5"
          />
          <circle cx="6.86" cy="26.92" r="6.85714" />
        </g>
      </g>
    </g>
  </svg>
);
